import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceSection = ({ title, icon, children, className = "" }) => {
  return (
    <div className={`bg-white rounded-lg shadow-professional border border-slate-200 p-6 ${className}`}>
      <div className="flex items-center space-x-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name={icon} size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl font-semibold text-text-primary">{title}</h2>
      </div>
      <div className="text-text-secondary leading-relaxed">
        {children}
      </div>
    </div>
  );
};

export default ComplianceSection;